export const logNameInConsole = () => {
    const name = 'PITTU PRASANTH';
    console.log('%c' + name, 'font-size: medium; color: steelBlue;');
  };
  